<template>
  <div
    v-if="company"
    class="row m-0 justify-content-end py-3 small"
  >
    <a
      v-if="company.twitter"
      :href="company.twitter"
      target="_blank"
    >
      <BushelBtn
        variant=""
        :ripple="false"
        class="p-0 px-1 mx-2 btn-sm"
        :style="{
          backgroundColor:
            theme.page_background_color,
          color: theme.page_button_color,
        }"
      >
        <i
          class="fab fa-fw fa-twitter-square"
          :style="{
            color:
              theme.page_button_color,
          }"
        />
        <span>Twitter</span>
      </BushelBtn>
    </a>

    <a
      v-if="company.instagram"
      :href="company.instagram"
      target="_blank"
    >
      <BushelBtn
        variant=""
        :ripple="false"
        class="p-0 px-1 mx-2 btn-sm"
        :style="{
          'background-color':
            theme.page_background_color,
          color: theme.page_button_color,
        }"
      >
        <i
          class="fab fa-fw fa-instagram"
          :style="{
            color:
              theme.page_button_color,
          }"
        />
        Instagram
      </BushelBtn>
    </a>

    <a
      v-if="company.facebook"
      :href="company.facebook"
      target="_blank"
    >
      <BushelBtn
        variant=""
        :ripple="false"
        class="p-0 px-1 mx-2 btn-sm"
        :style="{
          'background-color':
            theme.page_background_color,
          color: theme.page_button_color,
        }"
      >
        <i
          class="fab fa-fw fa-facebook"
          :style="{
            color:
              theme.page_button_color,
          }"
        />
        Facebook
      </BushelBtn>
    </a>

    <a
      v-if="company.website"
      :href="company.website"
      target="_blank"
    >
      <BushelBtn
        variant=""
        :ripple="false"
        class="p-0 px-1 mx-2 btn-sm"
        :style="{
          'background-color':
            theme.page_background_color,
          color: theme.page_button_color,
        }"
      >
        <i
          class="fas fa-fw fa-external-link-square-alt"
          :style="{
            color:
              theme.page_button_color,
          }"
        />
        Website
      </BushelBtn>
    </a>
  </div>
</template>
<script>
export default {
  props: {
    company: { type: Object },
    theme: { type: Object },
  },
};
</script>
